/* eslint react-hooks/exhaustive-deps: "warn" */

import { useInt } from 'hooks/useInt';

import { Button } from 'ui/atoms/Button/Button';
import { Faq } from 'ui/atoms/Faq/Faq';
import { AccessRoutes } from 'ui/organisms/AccessRoutes/AccessRoutes';
import { CtaSection } from 'ui/organisms/CtaSection/CtaSection';

import { TechnologyHero } from 'landing-pages/technology/sections/TechnologyHero/TechnologyHero';
import { TechnologyFields } from 'landing-pages/technology/sections/TechnologyFields/TechnologyFields';
import { TechnologyRegis } from 'landing-pages/technology/sections/TechnologyRegis/TechnologyRegis';
import { TechnologyRegistries } from 'landing-pages/technology/sections/TechnologyRegistries/TechnologyRegistries';
import { TechnologySecurity } from 'landing-pages/technology/sections/TechnologySecurity/TechnologySecurity';
import { TechnologySourcing } from 'landing-pages/technology/sections/TechnologySourcing/TechnologySourcing';
import { TechnologyTeams } from 'landing-pages/technology/sections/TechnologyTeams/TechnologyTeams';

import styles from './TechnologyPage.module.scss';

import { getAccessRoutes, getFaqItems } from './TechnologyPage.data';

export const TechnologyPage = () => {
  const { t } = useInt();

  return (
    <div className={styles.wrapper}>
      <TechnologyHero />
      <TechnologyRegistries />
      <TechnologySourcing />
      <TechnologyTeams />
      <TechnologyRegis />
      <TechnologyFields />
      <TechnologySecurity />
      <AccessRoutes
        background="light"
        heading={t('How to access the data.')}
        lede={t('Seven routes into the same primary, government-sourced dataset — pick the one that fits your stack.')}
        routes={getAccessRoutes(t)}
      />
      <CtaSection
        spotlight
        title={t('Start with a key, not a meeting.')}
        description={t(
          'Resolve one of your own records and read the source block. If it does what you need, the commercial conversation is a short one.',
        )}
        actions={
          <>
            <Button type="blue" size="xl" href="/free-trial">
              {t('Get a test key')}
            </Button>
            <Button type="dark-outline" size="xl" href="/book-a-demo">
              {t('Talk to a solutions engineer')}
            </Button>
            <Button type="dark-outline" size="xl" href="https://api.globaldatabase.com/docs/v2">
              {t('Documentation')}
            </Button>
          </>
        }
      />
      <Faq className={styles.faq} title={t('Before you book the call')} data={getFaqItems(t)} />
    </div>
  );
};
